import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import { Barfly, BarflyMapEditor } from 'containers'

export const BarflyRouter = () => {
  return (
    <Routes>
      <Route index element={<Barfly />} />
      <Route path="edit" element={<BarflyMapEditor />} />
    </Routes>
  )
}
